import { connect } from "react-redux";
import ToolkitInspectionView from './toolkitInspectionView';
import { bindActionCreators } from "redux";
import {fetchMaterialInspection} from 'services/redux/ToolkitInspection/action'

const mapStateToProps = (state) => ({
    fetchMaterialInspetionList: state.toolkitInspection.fetchMaterialInspetionList
})

const mapDispatchToProps = (dispatch) => 
    bindActionCreators({
        fetchMaterialInspection
    }, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ToolkitInspectionView);